// api.js
import red from "../assets/images/red_dot.png";
import green from "../assets/images/green_dot.png";
import active from "../assets/images/active_school.png";
import inactive from "../assets/images/inactive_school.png";

// Set or remove the Authorization token
export const getGreen = () => {
  return green;
};
export const getRed = () => {
  return red;
};
export const getActive = () => {
  return active;
};
export const getInactive = () => {
  return inactive;
};


